import Label from '@/models/Label'
import Paginator from '@/models/Paginator'
import { label as backend } from '@/api'
import { common as pathLoader} from '@/api'

export default {

  namespaced: true,

  state: {
    label: new Label,
    labels: new Paginator,
    label_list: []
  },

  mutations: {
    setLabel: (state, payload) => state.label = payload,
    setLabels: (state, payload) => state.labels = payload,
    setLabelList: (state, payload) => state.label_list = payload,
    clear: (state) => state.label = new Label,
    name: (state, payload) => state.label.name = payload,
    color: (state, payload) => state.label.color = payload,
    company: (state, payload) => state.label.company_id = payload,
  },

  actions: {
    save: ({state}) => new Promise((resolve, reject) => {
      if(state.label.id) {
         backend.update(state.label, ({data}) => resolve(data), error => reject(error))
      } else {
        backend.store(state.label, ({data}) => resolve(data), error => reject(error))
      }
    }),
    loadLabels: ({commit}, payload) => new Promise((resolve, reject) => {
      pathLoader.loadPath(payload, ({data}) => {
        commit('setLabels', data)
        resolve()
      }, error => reject(error))
    }),
    loadList: ({commit}) => new Promise((resolve, reject) => {
      backend.list(({data}) => {
        commit('setLabelList', data)
        resolve()
      }, error => reject(error))
    }),
    loadListByCompany: ({commit}, companyId) => new Promise((resolve, reject) => {
      backend.listByCompany(companyId, ({data}) => {
        commit('setLabelList', data)
        resolve()
      }, error => reject(error))
    }),
    load: ({commit}, labelId) => new Promise((resolve, reject) => {
      backend.load(labelId, ({data}) => {
        commit('setLabel', data)
        resolve()
      }, error => reject(error))
    })
  },

  getters: {
    labels: state => state.labels,
    labelList: state => state.label_list,
    label: state => state.label,
  }

}
